import { createStyles, makeStyles } from '@material-ui/core';
import Colors from '../../../../constants/Colors';
import { neutral, orange } from '../../../../shared/styles/colors';

export const disclaimerStyles = makeStyles(() =>
  createStyles({
    container: {
      backgroundColor: orange[10],
      borderLeft: `3px solid ${orange[60]}`,
      gridArea: 'disclaimer',
    },
    content: {
      backgroundColor: orange[10],
      borderLeft: `3px solid ${orange[60]}`,
      gridArea: 'disclaimer',
    },
    primaryText: {
      fontFamily: 'PP Object Sans',
      color: `${neutral[100]}`,
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    btnSecondary: {
      minWidth: '9.125rem',
      color: Colors.SECONDARY_COLOR_DARK,
    },
  }),
);
